export enum CIVILITY {
  NOT_SET = 'NotSet',
  MR = 'Mr',
  MRS = 'Mrs',
}
